import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import authManager from './utils/auth'
import dialog from './utils/dialog'

Vue.config.productionTip = false

authManager.init(store)

Vue.prototype.$auth = authManager
Vue.prototype.$alert = dialog.alert
Vue.prototype.$confirm = dialog.confirm
Vue.prototype.$success = dialog.success
Vue.prototype.$error = dialog.error
Vue.prototype.$warning = dialog.warning

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
